import React, { FC } from 'react'

import { getStyledElementProps } from '@/utils'
import { WithChildren } from '@/types'

import styles from './card.module.scss'

export const Card: FC<WithChildren> = ({ children, ...props }) => {
  const styledProps = getStyledElementProps(props, styles['root'])
  return <div {...styledProps}>{children}</div>
}
